import { Component } from '@angular/core';
//import { IonicPage, NavController } from 'ionic-angular';
//import { HomePage } from '../home/home';

//import { CuadrillasPage } from '../cuadrillas/cuadrillas';
//@IonicPage()
@Component({
  selector: 'page-pc-tabs',
  templateUrl: 'pc-tabs.html'
})
export class PcTabsPage {
  cuadrillasRoot = 'CuadrillasPage'
  partesRoot = 'PartesPage'
  personalRoot = 'PersonalPage'
  variedadesRoot = 'VariedadesPage'
  ajustesRoot = 'AjustesPage'
  
  constructor(/*public navCtrl: NavController*/) {}

}



// WEBPACK FOOTER //
// ./src/pages/pc-tabs/pc-tabs.ts